import { get } from "lodash";
import env from "@beam-australia/react-env";

import { GlobalErrorType } from "../types/global-type";
import { safeNumber } from "../utils/app";

export const AUTH_TOKEN = "treelab-auth-token";

// 请求超时时间
export const TIME_OUT = 60 * 1000;

// 轮询时间间隔
// @ts-ignore
const e = env();
export const POLL_TIME_INTERVAL = safeNumber(get(e, "REACT_APP__POLL_TIME_INTERVAL", undefined), 60000);
export const POLL_DELAY_OFFSET = safeNumber(get(e, "REACT_APP__POLL_DELAY_OFFSET", undefined), 10000);

export const GlobalErrorMessageId: { [key in GlobalErrorType]: string } = {
  [GlobalErrorType.NOT_TABLE_PERMISSION]: "error.not.permission",
  [GlobalErrorType.NETWORK_ERROR]: "error.network",
  [GlobalErrorType.RESPONSE_ERROR]: "error.response",
  [GlobalErrorType.SERVER_ERROR]: "error.server",
};

// 进行 group 时 暂时将若干个 key 由该 string 拼接成一个 key 进行计算
export const GROUP_KEY_SPLICING = "__=#=_@_+~+__";

// global format 盐
export const FORMAT_KEY_SPLICING = "_fy20hf242g232ddfds______";

// 某个用于计算 string 所占用 dom 宽度的 div 的 id
export const EXTERNAL_MOUNT_DIV_ID = "external_mount";

// any[] => string 用于拼接的字符串
export const FORMAT_NAME_SPLICING = ", ";

// 当 group value 为 '' 时 echarts 的 legend 会过滤掉 '' 需要手动加key
// 只要这个 key 不存在于 tableData 就会在 format 时当成 空 处理
export const GROUP_EMPTY_KEY = `empty_f923fe${FORMAT_KEY_SPLICING}_fhowfeempty`;

// 字体
export const FONT_FAMILY = '"SF Pro text", "PingFang SC", "Microsoft Yahei", Roboto, sans-serif';
